import { render, staticRenderFns } from "./MaterialsWinEdit.vue?vue&type=template&id=3f309174&scoped=true&"
import script from "./MaterialsWinEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialsWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsWinEdit.vue?vue&type=style&index=0&id=3f309174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f309174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f309174')) {
      api.createRecord('3f309174', component.options)
    } else {
      api.reload('3f309174', component.options)
    }
    module.hot.accept("./MaterialsWinEdit.vue?vue&type=template&id=3f309174&scoped=true&", function () {
      api.rerender('3f309174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MaterialsWinEdit.vue"
export default component.exports